// extracted by mini-css-extract-plugin
module.exports = {"breadCrumb":"style_breadCrumb__1cpuU","breadCrumb--withArrow":"style_breadCrumb--withArrow__1lkAQ"};